<p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [style]="{width: '400px'}">
      <ng-template pTemplate="header">
        <span>Recortar Foto</span>
      </ng-template>
      <div *ngIf="imageUrl">
          <image-cropper
              [imageBase64]="imageUrl"
              [maintainAspectRatio]="true"
              [aspectRatio]="1/1"
              format="png"
              [output]="'base64'"
              [onlyScaleDown]="false"
              (imageCropped)="imageCropped($event)">
          </image-cropper>
      </div>
      <ng-template pTemplate="footer">
        <button pButton label="Cancelar" class="p-ripple p-element p-button p-component p-button-warning p-button-rounded ml-2" (click)="cancelar()">Cancelar</button>
        <button pButton label="Aceptar" class="p-ripple p-element p-button p-component p-button-accent p-button-rounded ml-1" (click)="confirmar()">Descargar Carnet</button>

      </ng-template>
    </p-dialog>
